"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Height = exports.Width = exports.Size = void 0;
var Size;
(function (Size) {
    Size["Unit"] = "u-size-unit";
    Size["UnitTwo"] = "u-size-unit-x2";
    Size["UnitThree"] = "u-size-unit-x3";
    Size["Quarter"] = "u-size-1/4";
    Size["Half"] = "u-size-1/2";
    Size["One"] = "u-size-1";
    Size["Two"] = "u-size-2";
    Size["Three"] = "u-size-3";
    Size["Four"] = "u-size-4";
    Size["Viewport"] = "u-size-100vp";
})(Size = exports.Size || (exports.Size = {}));
var Width;
(function (Width) {
    Width["Fill"] = "u-width-100pc";
    Width["Unit"] = "u-width-unit";
    Width["Quarter"] = "u-width-1/4";
    Width["Half"] = "u-width-1/2";
    Width["One"] = "u-width-1";
    Width["Two"] = "u-width-2";
    Width["Three"] = "u-width-3";
    Width["Four"] = "u-width-4";
    Width["Five"] = "u-width-5";
    Width["Six"] = "u-width-6";
    Width["Eight"] = "u-width-8";
    Width["MinOne"] = "u-min-width-1";
    Width["MaxOne"] = "u-max-width-1";
    Width["MaxFill"] = "u-max-width-100pc";
})(Width = exports.Width || (exports.Width = {}));
var Height;
(function (Height) {
    Height["Fill"] = "u-height-100pc";
    Height["Unit"] = "u-height-unit";
    Height["Quarter"] = "u-height-1/4";
    Height["Half"] = "u-height-1/2";
    Height["One"] = "u-height-1";
    Height["Two"] = "u-height-2";
    Height["Viewport"] = "u-height-100vh";
    Height["MinOne"] = "u-min-height-1";
    Height["MaxFill"] = "u-max-height-100pc";
})(Height = exports.Height || (exports.Height = {}));
//# sourceMappingURL=Size.js.map